import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "./styles/UpperBar.css";
import "./styles/HeaderStyle.css";

export default function UpperBar() {
  const navigate = useNavigate();
  const [logo, setLogo] = useState("");
  const [tel, setTel] = useState("");
  const [contact, setContact] = useState("");
  const [education, setEducation] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  const call = (tel: string) => {
    var call_app = window.open("tel:" + tel, "_self");
    call_app!.close();
  };

  useEffect(() => {
    if (
      window.location.href == "http://localhost:3000/contact" ||
      window.location.href == "https://new.medicinafetalmexico.com/contact" ||
      window.location.href == "https://new.medicinafetalmexico.com/privacy" ||
      window.location.href == "http://localhost:3000/privacy"
    ) {
      setLogo("/img/mfm-blue.png");
      setTel("(33) 281 522 00");
      setContact("+523328152200");
      setEducation(true);
    } else {
      setLogo("/img/mfm-copyright.png");
      setTel("(+52) 3310824629");
      setContact("+523310824629");
      setEducation(false);
    }
  }, [window.location.href]);

  const navbar: HTMLElement | null = document.querySelector('#NavBar');
  const handleScroll = () => {
    const height: number = navbar?.offsetTop || 0;
    setIsSticky(window.scrollY > height)
  }
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });
  return (
    <>
      {education ? (
        <div className="upperBar-costume">
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%", height: "auto", backgroundColor: "rgba(255, 255, 255, 0.95)", position: "fixed", top: "0", left: "0", padding: "10px 20px", }} className="upperBar" >
            <div className="upperBar-contact-info">
              <div onClick={() => call(contact)}>
                <i className="fa fa-phone" style={{ marginRight: "5px" }} aria-hidden="true"
                />
                {tel}
              </div>
              <img
                onClick={() => window.open("https://wa.me/523328152200")}
                className="social-icon-bar"
                width="24px"
                src={process.env.PUBLIC_URL + "/img/whats.png"}
              />
              <p> | </p>
              <a href="https://www.instagram.com/medicinafetalmexico/?hl=es">
                <img
                  className="social-icon-bar"
                  width="15px"
                  src={process.env.PUBLIC_URL + "/img/instagram.jpg"}
                />
              </a>
              <a href="https://www.facebook.com/people/Medicina-Fetal-M%C3%A9xico/100087722166533/">
                <img
                  className="social-icon-bar"
                  width="15px"
                  src={process.env.PUBLIC_URL + "/img/facebook.png"}
                />
              </a>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <div className="upperBar-img">
                <a href="https://medicinafetalmexico.com/">
                  <img
                    className="upperBar-logo"
                    style={{ cursor: "pointer", width: "300px" }}
                    src={process.env.PUBLIC_URL + logo}
                  />
                </a>
              </div>
              <div className="menu-upperBar">
                <div className="menu-upperBar-text">
                  <ul className="dropdown">
                    <li>
                      <a href="https://medicinafetalmexico.com/">Inicio</a>
                      <ul>
                        <li>
                          <a href="https://medicinafetalmexico.com/que-es-la-medicina-fetal">
                            ¿Qué es la Medicina Fetal
                          </a>
                        </li>
                        <li>
                          <a href="https://medicinafetalmexico.com/quienes-somos">
                            Somos - Medicina Fetal México
                          </a>
                        </li>
                        <li>
                          <a href="https://medicinafetalmexico.com/testimonios">
                            Testimonios
                          </a>
                        </li>
                        <li>
                          <a href="https://medicinafetalmexico.com/tecnologia">
                            Tecnología
                          </a>
                        </li>
                        <li>
                          <a onClick={() => navigate("/specialists")}>
                            Especialistas CV
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>

                  <ul className="dropdown">
                    <li>
                      <a href="https://ipregnancymfm.com.mx/">Diagnóstico Prenatal</a>
                      <ul>
                        <li>
                          <a href="#">
                            Servicios
                            <img
                              className="social-icon-bar"
                              width="6px"
                              src={process.env.PUBLIC_URL + "/img/arrow.png"}
                              style={{ opacity: "20%" }}
                            />
                          </a>
                          <ul>
                            <li>
                              <a href="https://ipregnancymfm.com.mx/diagnostico-prenatal-avanzado">
                                Diagnóstico Prenatal Avanzado
                              </a>
                            </li>
                            <li>
                              <a href="https://ipregnancymfm.com.mx/doppler-fetal-basico-y-avanzado">
                                Doppler Fetal Básico y Avanzado
                              </a>
                            </li>
                            <li>
                              <a href="https://ipregnancymfm.com.mx/ecocardiografia-fetal">
                                Ecocardiografía Fetal
                              </a>
                            </li>
                            <li>
                              <a href="https://ipregnancymfm.com.mx/neurosonografia-fetal">
                                Neurosonografía Fetal
                              </a>
                            </li>
                            <li>
                              <a href="https://ipregnancymfm.com.mx/procedimientos-invasivos">
                                Procedimientos invasivos de alta<br></br>
                                complejidad
                              </a>
                            </li>
                            <li>
                              <a href="https://ipregnancymfm.com.mx/prueba-de-madurez-pulmonar">
                                Prueba de Madurez Pulmonar
                              </a>
                            </li>
                            <li>
                              <a href="https://ipregnancymfm.com.mx/monitorizacion-cardiaca-fetal">
                                Monitorización Cardiaca Fetal a Distancia
                              </a>
                            </li>
                            <li>
                              <a href="https://ipregnancymfm.com.mx/clinica-de-embarazo-gemelar">
                                Clínica de Embarazo Gemelar
                              </a>
                            </li>
                            <li>
                              <a href="https://ipregnancymfm.com.mx/neurodesarrollo">
                                Neurodesarrollo
                              </a>
                            </li>
                            <li>
                              <a href="https://ipregnancymfm.com.mx/psicologia">
                                Psicología
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="https://ipregnancymfm.com.mx/tecnologia">
                            Tecnología
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            Centros
                            <img
                              className="social-icon-bar"
                              width="6px"
                              src={process.env.PUBLIC_URL + "/img/arrow.png"}
                              style={{ opacity: "20%" }}
                            />
                          </a>
                          <ul>
                            <li>
                              <a href="https://production.d34ndqfwbcb776.amplifyapp.com/contact">
                                Centro Guadalajara
                              </a>
                            </li>
                            <li>
                              <a href="https://medicinafetalmexico.com/centro-queretaro">
                                Centro Querétaro
                              </a>
                            </li>
                            <li>
                              <a href="https://production.d34ndqfwbcb776.amplifyapp.com/contact">
                                Centro Morelia
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li>
                          <a href="https://production.d34ndqfwbcb776.amplifyapp.com/contact">
                            Contacto
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>

                                    <ul className="dropdown">
                                        <li><a href="https://ipregnancymfm.com.mx/">Cirugía Fetal</a>
                                            <ul>
                                                <li><a href="#">
                                                    Servicios
                                                    <img className='social-icon-bar' width="6px" src={process.env.PUBLIC_URL + "/img/arrow.png"} style={{ opacity: "20%" }} />
                                                </a>
                                                    <ul>
                                                        <li><a href="https://ipregnancymfm.com.mx/diagnostico-prenatal-avanzado">Diagnóstico Prenatal Avanzado</a></li>
                                                        <li><a href="https://ipregnancymfm.com.mx/doppler-fetal-basico-y-avanzado">Doppler Fetal Básico y Avanzado</a></li>
                                                        <li><a href="https://ipregnancymfm.com.mx/ecocardiografia-fetal">Ecocardiografía Fetal</a></li>
                                                        <li><a href="https://ipregnancymfm.com.mx/neurosonografia-fetal">Neurosonografía Fetal</a></li>
                                                        <li><a href="https://ipregnancymfm.com.mx/procedimientos-invasivos">
                                                            Procedimientos invasivos de alta<br></br>
                                                            complejidad</a></li>
                                                        <li><a href="https://ipregnancymfm.com.mx/prueba-de-madurez-pulmonar">Prueba de Madurez Pulmonar</a></li>
                                                        <li><a href="https://ipregnancymfm.com.mx/monitorizacion-cardiaca-fetal">Monitorización Cardiaca Fetal a Distancia</a></li>
                                                        <li><a href="https://ipregnancymfm.com.mx/clinica-de-embarazo-gemelar">Clínica de Embarazo Gemelar</a></li>
                                                        <li><a href="https://ipregnancymfm.com.mx/neurodesarrollo">Neurodesarrollo</a></li>
                                                        <li><a href="https://ipregnancymfm.com.mx/psicologia">Psicología</a></li>
                                                    </ul>
                                                </li>
                                                <li><a href="https://ipregnancymfm.com.mx/tecnologia">Tecnología</a></li>
                                                <li><a href="#">
                                                    Centros
                                                    <img className='social-icon-bar' width="6px" src={process.env.PUBLIC_URL + "/img/arrow.png"} style={{ opacity: "20%" }} />
                                                </a>
                                                    <ul>
                                                        <li><a href="https://production.d34ndqfwbcb776.amplifyapp.com/contact">Centro Guadalajara</a></li>
                                                        <li><a href="https://medicinafetalmexico.com/centro-queretaro">Centro Querétaro</a></li>
                                                        <li><a href="https://production.d34ndqfwbcb776.amplifyapp.com/contact">Centro Morelia</a></li>
                                                    </ul>
                                                </li>
                                                <li><a href="https://production.d34ndqfwbcb776.amplifyapp.com/contact">Contacto</a></li>
                                            </ul>
                                        </li>
                                    </ul>

                  <ul className="dropdown">
                    <li>
                      <a href="/courses">Educación</a>
                      <ul>
                        <li>
                          <a href="/courses">Cursos, Diplomados, Posgrados</a>
                        </li>
                        {/* 
                        <li>
                          <a href="/vc/courses/aTL2HT3ibBBFmm0xZ8Z2">
                            Congreso Internacional
                          </a>
                        </li>
                        */}
                        <li>
                          <a href="/rotations">Estancias de rotación</a>
                        </li>
                        <li>
                          <a href="/investigations">Investigación</a>
                        </li>
                        <li>
                          <a href="https://www.virtualcampusmfm.com/">
                            Campus Virtual
                          </a>
                        </li>
                        <li>
                          <a href="https://www.fuve.app/">FUVE</a>
                        </li>
                        <li>
                          <a href="http://www.orvo.com.mx/">ORVO</a>
                        </li>
                        <li>
                          <a href="/teachers">Profesorado</a>
                        </li>
                        <li>
                          <a href="/collaborations">
                            Colaboraciones académicas
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <ul className="dropdown">
                    <li>
                      <a href="https://fundacionmfm.com/">Fundación</a>
                    </li>
                  </ul>
                  <ul className="dropdown">
                    <li>
                      <a href="https://medicinafetalmexico.com/prensa">
                        Prensa
                      </a>
                    </li>
                  </ul>

                  <ul className="dropdown">
                    <div
                      className="btn-upperBar"
                      onClick={() => navigate("/contact")}
                    >
                      Contacto
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div id="NavBar" className={`header ${isSticky ? 'sticky' : ''}`}>
          <div className="header-data">
            <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
              <img style={{ width: "150px" }} src={process.env.PUBLIC_URL + logo} alt="" />
              <div className="header-contact">
                <div onClick={() => call(contact)}> <i /> <div className="fa fa-phone"></div> {tel} </div>
                <img onClick={() => window.open("https://wa.me/523310824629")} src={process.env.PUBLIC_URL + "/img/whats.png"} />
                <p className="separator"> | </p>
                <a href="https://www.instagram.com/mfm.education" target="_blank">
                  <img src={process.env.PUBLIC_URL + "/img/instagram.jpg"} />
                </a>
                <a href="https://es-la.facebook.com/medicinafetalmexico.educacion/" target="_blank">
                  <img className="social-icon-bar" width="15px" src={process.env.PUBLIC_URL + "/img/facebook.png"} />
                </a>
              </div>
            </div>
            <br></br>
            <div className="header-categories">
              <a href="https://medicinafetalmexico.com/" className="nav-link"> Inicio </a>
              <a href="/courses" className="nav-link"> Cursos </a>
              <a href="/vc/courses/do5ovvE39ya2HXJ7n6jN" className="nav-link"> Congreso </a>
              <a href="/vc/courses/MnXtx29x1MUVvOcVVTBV" className="nav-link"> Posgrado </a>
              <a href="/rotations" className="nav-link"> Rotación </a>
              <a href="/investigations" className="nav-link"> Investigación </a>
              <a href="https://www.virtualcampusmfm.com/" className="nav-link" > Campus Virtual </a>
              <a href="https://www.fuve.app/" className="nav-link"> FUVE </a>
              <a href="http://www.orvo.com.mx/" className="nav-link"> ORVO </a>
              <a href="/teachers" className="nav-link"> Profesorado </a>
              <a href="/collaborations" className="nav-link"> Colaboraciones </a>
              <div className="" onClick={() => navigate("/contact")} > {" "}Contacto{" "} </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};